@use '../../design-tokens/border-radius/border-radius' as *;
@use '../../design-tokens/typography/typography' as *;

@layer design-system {
  .markdownStyles {
    @include typography-v2-body-base;
    margin-bottom: 16px;
    overflow: auto;

    h1 {
      @include typography-v2-title-lg;
    }

    h2 {
      @include typography-v2-title-md;
    }

    h3 {
      @include typography-v2-title-base;
    }

    h4 {
      @include typography-v2-title-base;
    }

    h5 {
      @include typography-v2-title-sm;
    }

    p {
      margin-bottom: 1em;
    }

    code:not(pre code) {
      padding: 4px;
      color: var(--text-primary);
      background-color: var(--surface-default);
      @include border-radius-r05;
    }

    ul {
      list-style-type: disc;
      margin: 1em 0;
      padding: 0 0 0 2em;
    }
  }
}
